export default "__VITE_ASSET__a61c6d8f__"